module.exports = __webpack_public_path__ + "static/earth_tremor_mtg_clb-168689f7f8771093bdb1dad3c1fbb026.webp";